let locales = {
    users_tab_subuser: 'User',
    users_tab_email: 'Email',
    users_tab_login_as_user: 'Login as User',
    users_tab_users: 'Users',
    users_tab_warning_message_sm: 'This action is not available to the user',
    users_tab_verify_tc: 'Verify TC',
    users_tab_accepted: 'Accepted',
    users_tab_pending: 'Pending',
    users_tab_reset_user_passowrd: 'Change Password',
    users_tab_reset_user_email: 'Change Email',
    users_tab_resend_invite: 'Resend Invite',
    users_tab_chanage_username: 'Change Username',
    users_tab_warning_message_resend: 'The resend invitation is available only on expired and pending registration status',
    users_tab_show_activities: 'Show Activities',
    users_tab_warning_message_reset_password: 'The change password is available only on active registration status',
    users_tab_id: 'Id',
};

//Merge Views
import sendWelcomeEmail from 'Modules/users/.components/sendWelcomeEmail/lan/en';
import resetSubUserPassword from 'Modules/users/.components/resetSubUserPassword/lan/en';

locales = { ...locales, ...sendWelcomeEmail, ...resetSubUserPassword };

export default locales;

